$(document).on('click','.cart-note',function(e){
  var $this = $(this);
  if($this.hasClass('active')){
    $this.removeClass('active');
    $this.next('.CartNote').slideUp();
  }else{
    $this.addClass('active');      
    $this.next('.CartNote').slideDown();
    $('.CartNote').val('');
  }
});

/*---------   Cart   ---------*/

$("#shoppingcart,.cart-close").on('click', function() {
  $("body").toggleClass("CartOpen");
  return false;
});

/*---------   Quantity Counter   ---------*/

$(function() {
  $('.plus').on('click', function() {
    var $qty = $(this).parents('.CartItem,.cartItem,.addto-cart-part').find("ul.QuantityBox li .QuantityInput");
    var currentVal = parseInt($qty.val(), 10);
    if (!isNaN(currentVal)) {
      $qty.val(currentVal + 1);
    }
  });
  $('.minus').on('click', function() {
    var $qty = $(this).parents('.CartItem,.cartItem,.addto-cart-part').find("ul.QuantityBox li .QuantityInput");
    var currentVal = parseInt($qty.val(), 10);
    if (!isNaN(currentVal) && currentVal > 1) {
      $qty.val(currentVal - 1);
    }
  });
  
  $('body').click(function(e){

    var popup = $(".cart-side-panel");
    if(!popup.is(e.target) && popup.has(e.target).length === 0){
      if ($("body").hasClass("CartOpen")){
        $("body").removeClass("CartOpen");
      }
    }
    
  });
  /*
  if($('.sidebar_vendor_li').length > 0){
    $('.sidebar_vendor_li').each(function(e){
      var currentLI = $(this);
      var dataLink = $(this).attr('data-link');
      var linkType = typeof dataLink
      if(linkType != undefined || linkType != 'undefined'){
        $.ajax({
          url:dataLink,
          type:'GET',
          success: function(data){
            var TotalCount = Number($(data).find('#total_products_count').attr('data-products_count'));
            if(TotalCount < 2){
              currentLI.addClass('hide');
            }
          }
        });
      }
    });
  }
  */
});
$(document).on('click','.close-announcement-bar',function(e){
  $(this).parents('#shopify-section-announcement-bar').hide();
});